/**
 *  公用弹层脚本
 */
(function(){
	
	var commonPopStr = '<div class="common-pop-wrap js_comPopWrap" style="display:none">'+
							'<div class="com-pop js_comPopCon">'+
								'<div class="com-pop-header">'+
									'<span class="dl-pop-header-title" >提示</span>'+
									'<div class="com-pop-close-btn js_comPopCloseBtn"></div>'+
								'</div>'+
								'<div class="com-pop-con js_popCon">'+
									'<div class="common-tip-pop">'+
			                            '<p class="tip js_countDownNumtip"></p>'+
			                        '</div>'+
								'</div>'+
							'</div>'+
							'<div class="mask"></div>'+
					   '</div>';
	var commonDoubleBtnsPopStr = '<div class="common-pop-wrap js_doublePopWrap" style="display:none">' +
		'<div class="com-pop js_comPopCon" style="width: 425px">' +
		'<div class="com-pop-tip">' +
		'</div>' +
		'<div class="com-pop-con js_popCon">' +
		'<div class="common-tip-pop" style="text-align: left">' +
		'<p class="tip js_doubletip"></p>' +
		'</div>' +
		'</div>' +
		'<div class="btns-wrap">' +
		'<div class="sure_btn js_popSureBtn">立即前往</div>' +
		'<div class="quit_btn js_doublecomPopCloseBtn">取消</div>' +
		'</div>' +
		'</div>' +
		'<div class="mask"></div>' +
		'</div>';
	/**
     * @constructor CommonFn 公共功能模块
     */
    function CommonPopFn(){
        //公共功能模块
    }
    
    CommonPopFn.prototype = {
    	/**
         * @function init 初始化
         */
        init:function(){
        	if( !$('.js_comPopWrap').length ){
        		$('body').append( commonPopStr );
			}
			if (!$('.js_doublePopWrap').length) {
				$('body').append(commonDoubleBtnsPopStr);
			}
        	this.closePopFn();
        },
        /**
         * @function  commonTipPops 公用弹层
         * @param {String} str 提示文本
         */
        commonTipPops:function(str, btnFn){
        	$('.js_countDownNumtip').html( str );
        	$('.js_comPopWrap').show();
        	if( btnFn ){
        		var btnStr = '<div class="sure_btn js_popSureBtn">确定</div>';
        		if( !$('.js_popSureBtn').length ){
        			$('.js_comPopCon').append( btnStr );
        			$('.js_comPopCon').css({'height':'170px','margin-top':'-85px'});
        			$('.js_popSureBtn').off('click').on('click', btnFn );
        			$('.js_comPopCloseBtn').off('click').on('click',btnFn );
        		}
        	}
		},
		commonDoubleTipPops: function (str, Fn, url) {
			$('.js_doubletip').html(str);
			if (url) {
				$('.js_doubletip').append('<a>实名认证详情</a>');
				$('.js_doubletip').find('a').attr("href",url);
			}
			$('.js_doublePopWrap').show();
			$('.js_popSureBtn').off('click').on('click', Fn);
			$('.js_comPopCon').css({ 'height': '210px', 'margin-top': '-85px' });

		},
        /**
         * @function closePopFn 关闭弹层 
         */
        closePopFn:function(){
        	$('.js_comPopCloseBtn').off('click').on('click',function(){
        		$('.js_comPopWrap').hide();
			});
			$('.js_doublecomPopCloseBtn').off('click').on('click',function(){
        		$('.js_doublePopWrap').hide();
            });
        }
    }
    
    window.commonPopFn = new CommonPopFn();
})()

$(function(){
	commonPopFn.init();
})